import { Types } from "../actions/BreakdownReasonGroupActions";

const initialState = {
    breakdownReasonGroupList: {},
    breakdownReasonGrouploading: false,
    isTaskUpdatedBreakdownReasonGroup: false,
};

export const breakdownReasonGroupReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_BREAKDOWN_REASON_GROUP_LIST:
            return {
                ...state,
                breakdownReasonGroupList: action.payload,
                breakdownReasonGrouploading: false,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdatedBreakdownReasonGroup: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdatedBreakdownReasonGroup: false,
            };
        default:
            return state;
    }
};
